import React, { useContext } from "react";
import Header from "../../components/Header";
import Agenda from "./pages/Agenda";
import Container from "../../componentsv2/Container";
import FinanceiroAgendaCare from "./pages/Financeiro";
import RelatoriosAgendaCare from "./pages/Relatorios";
import { useAgendaCareContext } from "../../Context/AgendaCareContext";
import { Context } from "../../Context/PermissoesContext";
import MenuCadastros from "./Components/MenuCadastros";

export default function AgendaCare() {
  const { aba, setAba } = useAgendaCareContext();
  const { checarPermissaoComAcao } = useContext(Context);
  const [openMenuCadastros, setOpenMenuCadastros] = React.useState(false);

  return (
    <>
      <Header titulo="Agenda Care" />
      <Container>
        <MenuCadastros open={openMenuCadastros} onClose={() => setOpenMenuCadastros(false)} />
        <div style={{ paddingBottom: "0" }} id="container-aba-ctrl">
          <button
            id={aba === 0 ? "button-aba-ctrl-samples-selected" : "aba0"}
            type="button"
            className="button-aba-ctrl"
            style={{ fontSize: "16px" }}
            onClick={() => {
              setAba(0);
            }}
          >
            Agenda
          </button>

          <button
            id="aba1"
            type="button"
            className="button-aba-ctrl"
            style={{ fontSize: "16px" }}
            onClick={() => {
              checarPermissaoComAcao("AGC004", () => {
                setOpenMenuCadastros(true);
              });
            }}
          >
            Cadastros e permissões
          </button>

          <button
            id={aba === 2 ? "button-aba-ctrl-samples-selected" : "aba2"}
            type="button"
            className="button-aba-ctrl"
            style={{ fontSize: "16px" }}
            onClick={() => {
              checarPermissaoComAcao("AGC005", () => setAba(2));
            }}
          >
            Relatórios
          </button>

          <button
            id={aba === 3 ? "button-aba-ctrl-samples-selected" : "aba3"}
            type="button"
            className="button-aba-ctrl"
            style={{ fontSize: "16px" }}
            onClick={() => {
              checarPermissaoComAcao("AGC003", () => setAba(3));
            }}
          >
            Financeiro
          </button>
        </div>
        {aba === 0 && <Agenda />}
        {aba === 2 && <RelatoriosAgendaCare />}
        {aba === 3 && <FinanceiroAgendaCare />}
      </Container>
    </>
  );
}
